import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SignatureRequestService } from 'src/app/services/signature-request.service';

@Component({
  selector: 'app-sign',
  templateUrl: './sign.component.html',
  styleUrls: ['./sign.component.sass']
})
export class SignComponent implements OnInit {

  constructor(private activated_route:ActivatedRoute,
              private signature_request:SignatureRequestService) {

  }

  ngOnInit(): void {
    this.listenSignatureRequestUuidQueryParam();
  }

  private listenSignatureRequestUuidQueryParam() {
    this.activated_route.paramMap.subscribe(
      data => {
        const signature_request_uuid = data.get('signature_uuid');
        if(signature_request_uuid!=null) {
          this.signature_request.init(signature_request_uuid);
        }
      }
    );
  }

}
